export default {"src":"/_next/static/media/MGM.a9d2dcb3.svg","height":18,"width":18};